(() => {
  const dialog = document.querySelector('#PreviewDialog');
  if (!dialog) return;
  let opener;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-preview]');
    if (trigger) {
      opener = trigger;
      document.querySelector('#PreviewImage').src = trigger.dataset.preview;
      document.querySelector('#PreviewImage').alt = trigger.dataset.title;
      document.querySelector('#PreviewTitle').textContent = trigger.dataset.title;
      dialog.showModal();
    }
    if (event.target.closest('[data-close-preview]') || event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => opener?.focus());
})();
